document.getElementById("selfie_img").style.display="none";
(function(){
   window.onload = function() {
       if (window.jQuery) {  
        // jQuery is loaded  
         
          document.getElementById("selfie_img").style.display="none";
          $(document).ready ( function(){
              $("#selfie_overlay").hide();

              var url_string = window.location.href

              var url = new URL(url_string);

              var imgid = url.searchParams.get("id");
              if(imgid != null && imgid != "None"){
                console.log("yes image")
                $('#selfie_img').attr('src', 'https://s.tangent.ai/user-image/mango/'+imgid);
                $('#selfie_img').attr('style', 'display:flex');
                if(document.getElementById("tangent-placeholder-img")!=undefined){
                  document.getElementById("tangent-placeholder-img").style.display="none";
                }
                setTimeout(function(){ $("#selfie_overlay").show(); }, 3000);

              }
            else{
              console.log("no image");
            }

              if(document.getElementById("Damage")!=null){
                document.getElementById("Damage").style.height = "auto";
                document.getElementById("Damage").className += " active";
              } else if(document.getElementById("Acid-Reflux")!=null){
                document.getElementById("Acid-Reflux").style.height = "auto";
                document.getElementById("Acid-Reflux").className += " active";
              }
              if(document.getElementById("Texture")!=null){
                document.getElementById("Texture").style.height = "auto";
                document.getElementById("Texture").className += " active";
              }

              var i, tablinks;
              tablinks = document.getElementsByClassName("tablinks");
              var oneTimeFlag = true;
              for (i = 0; i < tablinks.length; i++) {
                if(tablinks[i].innerHTML == "Damage" || tablinks[i].innerHTML == "Acid Reflux" || tablinks[i].innerHTML == "Texture"){

                  if(oneTimeFlag){
                      tablinks[i].className += " active";
                      oneTimeFlag = false
                  }
                }
              }

          });
         
        } else {
            // jQuery is not loaded
            console.log("Jquery not loaded");
        }

     addProductInMarketsDisclaimer();

  }
   

  
})();

function addProductInMarketsDisclaimer(){
  let mainElement = document.getElementById("main");
  let disclaimerElement = document.createElement("div");
  let containerElement = mainElement.querySelector('.Container')
  
  disclaimerElement.style.fontSize = "14px";
  disclaimerElement.className = "PageContent PageContent--narrow Rte SkinQuiz-margin";
  
  disclaimerElement.innerHTML = "* This website may contain information or recommendations for products, not all of which are available in every country. Please contact a skincare professional <a href=\"https://osmosisbeauty.com/apps/store-locator\">near you</a> to inquire about product availability.";
  
  containerElement.appendChild(disclaimerElement);
}

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.height = "0px";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.height = "auto";
  evt.currentTarget.className += " active";
  
  if(tabName == 'Capillaries'){
    var tablinks2;
    var oneTimeFlag = true;
    tablinks2 = document.getElementsByClassName("tablinks2");
  	for (i = 0; i < tablinks2.length; i++) {
      if(tablinks2[i].innerHTML == "Damage" || tablinks2[i].innerHTML == "Acid Reflux" || tablinks2[i].innerHTML == "Texture"){

        if(oneTimeFlag){
          tablinks2[i].className += " active";
          oneTimeFlag = false
        }
      }
    }
  }
}

function openTab2(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent2");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.height = "0px";
  }
  tablinks = document.getElementsByClassName("tablinks2");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.height = "auto";
  evt.currentTarget.className += " active";
}
